module.exports = __webpack_public_path__ + "static/img/ws-img-newsletter-desktop.5515aae.jpg";